<template>
  <div class="childtrackingsystem-edit">
    <div class="row bg-white">
      <br>
    </div>
      <div v-if="isLoading" class="row bg-white">
          <div class="col-12 text-center">
              <img
                  src="../../assets/img/loading.gif"
                  alt="Loading"
                  style="width: 80px; height: 80px;"
              >
          </div>
      </div>
      <div class="row bg-white" v-if="isError">
          <div class="col-12 alert alert-danger text-center">{{ errorMessage }}</div>
      </div>
      <div class="row bg-white" v-if="isSuccess">
          <div class="col-12 alert alert-info text-center">Observatie is succesvol opgeslagen</div>
      </div>
    <div class="row bg-white">
      <div class="col-12">
        <br>
        <input
            id="searchQuestion"
            v-model="searchQuestion"
            type="text"
            class="form-control"
            placeholder="Zoek een doel"
            value=""
            @input="getResults()"
        ><br>
      </div>
    </div>
    <div class="row bg-white">
      <div
          v-for="childDetails in analysedChildren"
          :key="childDetails.id"
          class="col-12"
      >
        <table style="border:0;width:100%;">
          <tr class="preHeader">
            <th style="height:50px;padding-left: 15px;">
              <b>{{ listTitle }}</b> van kind <b>{{ childDetails.full_name }}</b> ({{ childDetails.age }} maanden)
            </th>
          </tr>
        </table>
        <table
            v-for="(category, cIdx) in childDetails.content"
            :key="cIdx"
            style="border:0;width:100%;"
        >
          <tr v-if="category.questions.length > 0" class="header">
            <th
                :style="'border:0; height: 50px; padding-left: 15px;color:' + category.color"
                colspan="3"
            >
              {{ category.name }}
            </th>
          </tr>
          <tr
              v-for="(question, cqIdx) in category.questions"
              :key="cqIdx"
              class="borderBottomShadow"
          >
            <td style="border:0;width:15px;">
              &nbsp;&nbsp;
            </td>
            <td style="border:0;padding-top:10px;vertical-align: middle;padding-left: 10px;margin-right: 5px;">
              {{ question.vraag }}
            </td>
            <td style="border:0;width:300px;padding-top:10px;vertical-align: middle;">
              <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                <tr>
                  <td
                      v-for="answer in question.answerPossibilities"
                      :key="answer.id"
                  >
                    <input v-if="!question.freeAnswer"
                           type="radio"
                           :id="'checkedAnswer-' + checkedList + '-' + childDetails.id + '-' + question.id + '-' + answer.id"
                           :name="'checkedAnswer-' + checkedList + '-' + childDetails.id + '-' + question.id"
                           @input="changeAnswer(checkedList, childDetails.id, question.id, answer.id, answer.note)"
                    />
                    <span v-if="!question.freeAnswer"
                          style="margin-left:5px;margin-right:5px;"
                          @click="setAnswerChecked(checkedList, childDetails.id, question.id, answer.id, answer.note)">
                      {{ answer.answer }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <textarea v-if="!question.freeAnswer"
                              :id="'answerNote-' + checkedList + '-' + childDetails.id + '-' + question.id"
                              :ref="'answerNote-' + checkedList + '-' + childDetails.id + '-' + question.id"
                              class="form-control"
                              :style="'height: 50px; display:' + question.displayAnswerNote"
                              @input="changeAnswerNote($event, checkedList, childDetails.id, question.id, question.freeAnswer, question.checkedAnswer)"
                    />
                    <textarea v-if="question.freeAnswer"
                              :id="'answerNote-' + checkedList + '-' + childDetails.id + '-' + question.id"
                              :ref="'answerNote-' + checkedList + '-' + childDetails.id + '-' + question.id"
                              class="form-control"
                              :style="'height: 50px; display:' + question.displayAnswerNote"
                              @input="changeAnswerNote($event, checkedList, childDetails.id, question.id, question.freeAnswer, question.checkedAnswer)"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <textarea
                        id="'answerNote-' + childDetails.id + '-' + question.id"
                        :ref="'answerNote-' + checkedList + '-' + childDetails.id + '-' + question.id"
                        class="form-control"
                        style="height: 50px; display: none;"
                        @input="changeAnswerNote($event, checkedList, childDetails.id, question.id, question.freeAnswer, question.checkedAnswer)"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <table
                  v-for="(subCategory, scIdx) in category.subcategories"
                  :key="scIdx"
                  style="border:0;width:100%;"
              >
                <tr class="header">
                  <th
                      :style="'border:0; height: 50px; padding-left: 15px;color:' + category.color"
                      colspan="3"
                  >
                    {{ category.name }}: {{ subCategory.name }}
                  </th>
                </tr>
                <tr
                    v-for="(subQuestion, scqIdx) in subCategory.questions"
                    :key="scqIdx"
                    class="borderBottomShadow"
                >
                  <td style="border:0;width:15px;">
                    &nbsp;&nbsp;
                  </td>
                  <td style="border:0;padding-top:10px;padding-left:10px;vertical-align: middle;margin-right: 15px;">
                    {{ subQuestion.vraag }}
                  </td>
                  <td style="border:0;width:300px;padding-top:10px;vertical-align: middle;">
                    <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                      <tr>
                        <td
                            v-for="answer in subQuestion.answerPossibilities"
                            :key="answer.id"
                        >
                          <input v-if="!subQuestion.freeAnswer"
                                 type="radio"
                                 :id="'checkedAnswer-' + checkedList + '-' + childDetails.id + '-' + subQuestion.id + '-' + answer.id"
                                 :name="'checkedAnswer-' + checkedList + '-' + childDetails.id + '-' + subQuestion.id"
                                 @input="changeAnswer(checkedList, childDetails.id, subQuestion.id, answer.id, answer.note)"
                          />
                          <span v-if="!subQuestion.freeAnswer"
                                style="margin-left:5px;margin-right:5px;"
                                @click="setAnswerChecked(checkedList, childDetails.id, subQuestion.id, answer.id, answer.note)">
                          {{ answer.answer }}
                        </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                    <textarea v-if="!subQuestion.freeAnswer"
                              :id="'answerNote-' + childDetails.id + '-' + subQuestion.id"
                              :ref="'answerNote-' + checkedList + '-' + childDetails.id + '-' + subQuestion.id"
                              class="form-control"
                              :style="'width:100%;height: 50px; display:' + subQuestion.displayAnswerNote +';'"
                              @input="changeAnswerNote($event, checkedList, childDetails.id, subQuestion.id, subQuestion.freeAnswer, subQuestion.checkedAnswer)"
                    />
                          <textarea v-if="subQuestion.freeAnswer"
                                    :id="'answerNote-' + childDetails.id + '-' + subQuestion.id"
                                    :ref="'answerNote-' + checkedList + '-' + childDetails.id + '-' + subQuestion.id"
                                    class="form-control"
                                    :style="'width:100%;height: 50px; display:' + subQuestion.displayAnswerNote"
                                    @input="changeAnswerNote($event, checkedList, childDetails.id, subQuestion.id, subQuestion.freeAnswer, subQuestion.checkedAnswer)"
                          />
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td
                style="border:0;vertical-align: top;padding: 10px; "
                colspan="3"
            >
              <div v-if="category.noteChecked === 'checked'">
                <b>{{ category.name }} opmerkingen</b>
                <textarea
                    :id="'categoryNote-' + checkedList + '-' + childDetails.id + '-' +category.id"
                    class="form-control"
                    style="height: 100px;"
                    @input="changeCategoryNote($event, checkedList, childDetails.id, category.id)"
                />
              </div>
            </td>
          </tr>
          <tr v-if="results[childDetails.id] > 0">
            <td
                style="border:0;"
                colspan="3"
            >
              <button
                  type="button"
                  class="button"
                  @click="uploadPhoto(results[childDetails.id], category.id)"
              >
                Upload
                foto's
              </button>
            </td>
          </tr>
        </table>

        <br><br>
        <table
            v-if="noteChecked === 'checked'"
            style="width:95%; height:150px; margin-left: 15px; margin-right: 15px; border:0;"
        >
          <tr>
            <td colspan="2">
              <div>
                <b>Observatielijst opmerkingen</b><br>
                <textarea
                    id="listNote"
                    class="text-input form-control"
                    style="height: 100px;"
                    @input="changeListNote($event, checkedList, childDetails.id)"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row row-cols-auto align-items-end pb-3 bg-white">
      <div class="col">
        <button
            class="btn btn-outline-secondary"
            @click="goBack()"
        >
          Terug
        </button>
      </div>
      <div class="col">
          Ingevuld door <select
            class="form-select form-select-sm"
            id="mentor"
            v-model="selectedMentor"
            name="mentor"
            @change="mentorChanged($event)"
        >
          <option
              value="0"
              selected
          >
            Kies...
          </option>
          <option
              v-for="mentor in mentors"
              :key="mentor.id"
              :value="mentor.id"
          >
            {{ mentor.name }}
          </option>
        </select>
      </div>
        <div class="col">
          <button
              class="btn btn-outline-primary"
              @click="saveAnalyseChildren()"
          >
            Opslaan
          </button>
      </div>
    </div>
    <br><br>
    <div
        v-if="isModal"
        class="modalLoader"
    >
      <div class="modal-content">
        <div
            class="modal-title"
            style="text-align: right; width:100%; padding-right: 10px;"
        >
          <button
              class="button"
              @click="closeModal()"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="col-sm-10">
              Bestanden uploaden:
              <input
                  id="photo"
                  ref="photo"
                  type="file"
                  class="form-control"
                  multiple="multiple"
              ><br>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
              class="button"
              type="button"
              name="upload"
              value="upload"
              @click="uploadSave()"
          >
            Opslaan upload
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChildtrackingsystemAnalysechild',
  components: {},
  // eslint-disable-next-line vue/require-prop-types
  props: ['checkedList', 'checkedChildren', 'checkedCategory', 'checkedQuestion'],
  data() {
    return {
      isLoading: false,
      listTitle: null,
      listNote: {},
      noteChecked: null,
      categories: [],
      answers: [],
      checkedAnswer: {},
      analysedChildren: [],
      categoryNote: {},
      answerNote: {},
      mentors: [],
      selectedMentor: 0,
      displayNote: null,
      isModal: false,
      upload_idCategory: 0,
      upload_idResult: 0,
      files: [],
      results: [],
      lists: [],
      answersChild: [],
      searchQuestion: '',
      isError: false,
      errorMessage: null,
      isSuccess: false
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.isLoading = true
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/analyseChild', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString, // @todo Fix for all groups
        children: this.checkedChildren,
        idList: this.checkedList,
        idCategory: this.checkedCategory,
        idQuestion: this.checkedQuestion,
        question: this.searchQuestion
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.analysedChildren = response.children
          this.listTitle = response.listTitle
          if (response.noteChecked > 0) this.displayNote = ''
          else this.displayNote = 'none'
          this.mentors = response.mentors
          this.isLoading = false
        }
      })
    },
    mentorChanged(event) {
      this.selectedMentor = event.target.value
      return event.target.value
    },
    changeAnswer(listId, childId, questionId, answerId, answerNoteActive) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.checkedAnswer ||= {};
      this.checkedAnswer[listId] ||= {};
      this.checkedAnswer[listId][childId] ||= {};
      this.checkedAnswer[listId][childId][questionId] = answerId;

      let $ref = this.$refs['answerNote-' + listId + '-' + childId + '-' + questionId]
      if (answerNoteActive === 'checked') {
        $ref[0].innerHTML = ''
        $ref[0].style.display = 'block'
      } else {
        $ref[0].innerHTML = ''
        $ref[0].style.display = 'none'
      }
    },
    setAnswerChecked(listId, childId, questionId, answerId, answerNoteActive) {
      let id = 'checkedAnswer-' + listId + '-' + childId + '-' + questionId + '-' + answerId
      document.getElementById(id).checked = true
      this.changeAnswer(listId, childId, questionId, answerId, answerNoteActive)
    },
    changeAnswerNote(event, listId, childId, questionId, freeAnswer, answerId) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.answerNote ||= {};
      (this.answerNote[listId] ||= {})[childId] ||= {};
      this.answerNote[listId][childId][questionId] = event.target.value;
      if (freeAnswer) {
        this.checkedAnswer ||= {};
        this.checkedAnswer[listId] ||= {};
        this.checkedAnswer[listId][childId] ||= {};
        this.checkedAnswer[listId][childId][questionId] = answerId;
      }
    },
    changeCategoryNote(event, listId, childId, categoryId) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.categoryNote ||= {};
      (this.categoryNote[listId] ||= {})[childId] ||= {};
      this.categoryNote[listId][childId][categoryId] = event.target.value;
    },
    changeListNote(event, listId, childId) {
      this.listNote ||= {};
      this.listNote[listId] ||= {};
      this.listNote[listId][childId] = event.target.value
    },
    saveAnalyseChildren() {
      this.isLoading = true
      window.scrollTo(0, 0);
      this.$request.post('/ChildTrackingSystem/saveAnalyseChild', {
        answers: this.checkedAnswer,
        categoryNote: this.categoryNote,
        answerNote: this.answerNote,
        listNote: this.listNote,
        lists: this.lists,
        idMentor: this.selectedMentor,
        children: this.analysedChildren,
        idCategory: this.checkedCategory,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        session_token: this.session.session_token,
        device_token: this.deviceToken,
        idResult: 0
      }).then((response) => {
          this.isLoading = false
          if (response.success) {
              this.isSuccess = true
              setTimeout(() => this.isSuccess = false, 40000)
              this.$router.push('/childtrackingsystem/results')
          } else if (response.error) {
              this.isError = true
              this.errorMessage = response.error
              setTimeout(() => this.isError = false, 40000)
          }
      })
    },
    uploadPhoto(idResult, idCategory) {
      this.isModal = true
      this.upload_idCategory = idCategory
      this.upload_idResult = idResult
    },
    closeModal() {
      this.isModal = false
    },
    uploadSave() {
      let files = this.$refs.photo.files
      for (let i = 0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('file', files[i])
        formData.append('session_token', this.session.session_token)
        formData.append('device_token', this.deviceToken)
        formData.append('upload_idCategory', this.upload_idCategory)
        formData.append('upload_idResult', this.upload_idResult)

        this.$store.commit('REGISTER_ACTIVE_REQUEST')
        // eslint-disable-next-line no-undef
        this.$request.post('/ChildTrackingSystem/uploadPhoto', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST')
          if (!response.uploaded) {
            alert(response.error)
          }
        })
      }
    },
    goBack() {
      window.location.reload()
    },
  }
}
</script>
<style scoped>
.table th {
  color: #222;
  background-color: #ffffff;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}

.button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  height: 40px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #F87137;
  color: #F87137;
}

.button:hover {
  border-color: #DE4808;
  color: #DE4808;
}

.button:active {
  border-color: #DE4808;
  color: #DE4808;
}

.button:focus {
  border-color: #DE4808;
  color: #DE4808;
  border-width: 2px;
}

select {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #c8c8c8 !important;
}

.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

input[type=radio] {
  transform: scale(1.4, 1.4);
  border-color: #888888;
}

.borderBottomShadow {
  border-bottom: 1px #ddd solid;
  height: 100px;
}

.header {
  color: #445161;
  background-color: #f0f0f5;
}

.preHeader {
  color: #445161;
  background-color: #dedee7;
}

</style>